import { LayoutComponent } from '../layout/layout.component';

import { LoginComponent } from './pages/login/login.component';
import { RecuperarSenhaComponent } from './pages/recuperar-senha/recuperar-senha.component';
import { CadastroComponent } from './pages/cadastro/cadastro.component';
import { IconsComponent } from './pages/icons/icons.component';
import { AcessoComponent } from './pages/acesso/acesso.component';
import { Routes } from "@angular/router";

export const routes: Routes = [

    { path: '', component: LoginComponent },

    {
        path: '',
        component: LayoutComponent,
        children: [
            { path: '', redirectTo: 'home', pathMatch: 'full' },
            { path: 'dashboard', loadChildren: () => import('./dashboard/dashboard.module').then(m => m.DashboardModule) },
            { path: 'sonar', loadChildren: () => import('./sonar/sonar.module').then(m => m.SonarModule) },
            { path: 'ranking', loadChildren: () => import('./ranking/ranking.module').then(m => m.RankingModule) },
            { path: 'usuarios', loadChildren: () => import('./usuarios/usuarios.module').then(m => m.UsuariosModule) },
            // { path: 'cadastros', loadChildren: () => import('./dashboard/dashboard.module').then(m => m.DashboardModule) },
            { path: 'graficos', loadChildren: () => import('./charts/charts.module').then(m => m.ChartsModule) },
            { path: 'ativacoes', loadChildren: () => import('./ativacoes/ativacoes.module').then(m => m.AtivacoesModule) },
            { path: 'carteira-cn', loadChildren: () => import('./carteira-cn/carteira-cn.module').then(m => m.CarteiraCnModule) },
            { path: 'pdvs', loadChildren: () => import('./pdvs/pdvs.module').then(m => m.PdvsModule) },
            { path: 'pdvs-admin', loadChildren: () => import('./pdvs-admin/pdvs-admin.module').then(m => m.PdvsAdminModule) },
            { path: 'posts', loadChildren: () => import('./posts/posts.module').then(m => m.PostsModule) },
            { path: 'treinamentos', loadChildren: () => import('./treinamentos/treinamentos.module').then(m => m.TreinamentosModule) },
            { path: 'resgates', loadChildren: () => import('./resgates/resgates.module').then(m => m.ResgatesModule) },
            { path: 'banners', loadChildren: () => import('./banners/banners.module').then(m => m.BannersModule) },
            { path: 'popups', loadChildren: () => import('./popups/popups.module').then(m => m.PopupsModule) },
            { path: 'chamados', loadChildren: () => import('./chamados/chamados.module').then(m => m.ChamadosModule) },
            { path: 'cloudloyalty', loadChildren: () => import('./cloudloyalty/cloudloyalty.module').then(m => m.CloudloyaltyModule) },
            { path: 'inconsistencias', loadChildren: () => import('./inconsistencias/inconsistencias.module').then(m => m.InconsistenciasModule) },
            { path: 'configuracoes', loadChildren: () => import('./configuracoes/configuracoes.module').then(m => m.ConfiguracoesModule) },
            { path: 'configuracao', loadChildren: () => import('./configuracao/configuracao.module').then(m => m.ConfiguracaoModule)},
            { path: 'apuracao', loadChildren: () => import('./apuracao/apuracao.module').then(m => m.ApuracaoModule)},
            { path: 'push-notification', loadChildren: () => import('./push/push-notification.module').then(m => m.PushNotificationModule) }

        ]
    },
    
    // Not lazy-loaded routes
    { path: 'login', component: LoginComponent },
    { path: 'recuperar-senha', component: RecuperarSenhaComponent },
    { path: 'primeiro-acesso', component: CadastroComponent },
    { path: 'icones', component: IconsComponent },
    { path: 'acesso-negado', component: AcessoComponent },

    // Not found
    { path: '**', redirectTo: 'login' }

];
